<template>
  <div class="productCenter">
    <div class="setwidth titleA">
      <img class="image" src="./indexImg/titleAPc.png"  alt="">
    </div>
    <div class=" cpxzTitleImg ">
        <img src="./indexImg/titlePc.png" alt="">
    </div>
    <!-- 产品列表 -->
    <div class=" setwidth cpxzList"  >
        <div class="cpxzitem" v-for="item in $store.state.productList" :key="item.ID"  @click="open(item.ID)">
            <div class="cpxzitemL">
                <!-- <img class="image" src="./indexImg/download.png" alt=""> -->
                    <el-image class="image" :src="item.TitlePic">
                       <div slot="error" class="image-slot">
                        <img class="noImage" src="~@/assets/img/noNews.png" alt="">
                       </div>
                     </el-image>
            </div>
            <div class="cpxzitemR" >
                <p>{{item.Title}}</p>
                <div class="cpxzitemRP">
                   {{item.Info}}
                </div>
                <!-- <a href='javascript:;'>
                  <img src="./indexImg/download.png" alt="" class="downLoad">
                </a> -->
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { getProductDown } from '@/api/product'
// 引入根路径
import request from '@/utils/request'
export default {
  data () {
    return {
      productDown: [] // 产品下载
    }
  },
  created () {
    this.getProductDown({ PageSize: 100, PageIndex: 1 })
  },
  mounted () {

  },
  methods: {
    async getProductDown (data) {
      const res = await getProductDown(data)
      if (res.Msg === '获取成功') {
        this.productDown = res.Data
        this.productDown.forEach(item => {
          item.Path = request.defaults.baseURL + item.Path
        })
        // console.log(this.productDown, '11111')
      }
    },
    open (id) {
      // this.$message.error('页面在加速更新中！')
      // this.$router.push('/productItem')
      // console.log('11111111')
      this.$router.push({ path: `/productItemShow/${id}` })
      // this.$router.push({ path: `/productItem/${id}/${name}` })
    }
  }

}
</script>

<style lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun:100/192;
  .productCenter{
    display:flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    box-sizing: border-box;
    .setwidth{
        width:100%;
    }
    .cpxz{
        // padding: 50px*$sun 839px*$sun;
        margin-top: 50px*$sun;
    }
    .titleA{
      height: 460px*$sun;
    }
}

.image{
    width: 100%;
    height: 100%;

}

.cpxz{
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FFFFFF;
    padding-bottom: 35px*$sun;

}
.cpxzTitleImg{
  width: 242px*$sun;
  height: 107px*$sun;
  margin: 50px*$sun auto;
  img{
    width: 100%;
    height: 100%;
  }
}
.cpxzList{
    display: flex;
    justify-content: space-between;
    padding: 0 300px*$sun;
    flex-wrap: wrap;
    background-color: #FFFFFF;
    overflow: hidden;
    /*
    margin: 0 auto; */
}
.cpxzitem{
    display: flex;
    width: 588px*$sun;
    height: 241px*$sun;
    margin: 15px*$sun 23px*$sun;
    transition: all 0.2s;
    float: left;
    .cpxzitemL{
        width: 294px*$sun;
        float: left;
        .image{
          width: 294px*$sun;
          height: 241px*$sun;
              .image-slot{
     width: 294px*$sun;
          height: 241px*$sun;
      .noImage{
       width: 294px*$sun;
          height: 241px*$sun;
      }
    }
        }
    }
}
.cpxzitem:hover{
   /* 盒子向上移动 */
    transform: translateY(-2px*$sun);
    /* 背景 */
    box-shadow: 5px*$sun 5px*$sun 5px*$sun rgba(19, 19, 20, 0.15);
    // text-shadow: 5px*$sun 5px*$sun 5px*$sun #7676f3;
 }
.cpxzitemR{
    width: 294px*$sun;
    background: url('./indexImg/white.png');
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px*$sun;
    float: right;
    font-weight: 500;
    .cpxzitemRP{
      width: 75%;
      height: 150px*$sun;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5;
      font-weight: 500;
      // white-space: nowrap;
      // text-overflow: ellipsis;
    }
}
.cpxzitemR p{
    margin-top: 40px*$sun;
    height: 29px*$sun;
    font-size: 22px*$sun;
    color: #2380E1;
    text-align: center;
    font-weight: 500;
}
.cpxzitemR div{
    text-align: center;
    padding: 0 40px*$sun;
    line-height:30px*$sun;
    color: #404145;
}
.cpxzitemR img {
    width: 34px*$sun;
    height:34px*$sun;
    margin-bottom: 28px*$sun;
}
.cpxzTwo{
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #F9FAFC;;
    padding:70px*$sun 832px*$sun 51px*$sun 832px*$sun;
    margin-top: 50px*$sun;
}
.rjxzT{
    display: flex;
    justify-content: center;
    margin-top: 35px*$sun;
    padding-top: 70px*$sun;
    padding-bottom: 50px*$sun;
    background-color: #F9FAFC;
}
.rjxzList{
    display: flex;
    justify-content: center;
    padding: 0 360px*$sun;
    padding-bottom: 40px*$sun;
    background-color: #F9FAFC;
    margin-bottom: 114px*$sun;

}
.rjxzItem{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 40px*$sun;
    margin: 0 30px*$sun;
    box-sizing: border-box;
    width: 278px*$sun;
    height: 395px*$sun;
    background: #FFFFFF;
    border: 1px*$sun solid #D7DBE8;
    border-radius: 10px*$sun;
    font-family: MicrosoftYaHei;
    font-size: 14px*$sun;
}
.rjxzItem img{
    width: 65.904px*$sun;
}
.rjxzItem span{
    font-size: 16px*$sun;
   line-height: 16px*$sun;
color: #9FA4AF;
}
.rjxzItem div{
    font-size: 20px*$sun;
    line-height: 16px*$sun;
    color: #4F4F6F;
}
.rjxzItem p {
    text-align: center;
    font-size: 14px*$sun;
    color: #9FA4AF;
    height: 100px*$sun;
    line-height:30px*$sun
}
.rjxzItem button{
    width: 128px*$sun;
    height: 34px*$sun;
    background: #FFFFFF;
    border: 1px*$sun solid #D7DBE8;
    box-shadow: 0px 0px 21px rgba(204,204,223,0.5);
    border-radius: 25px;
}
.downLoad{
  cursor:pointer;
}

</style>
